import httpManager from "@/app/shared/utils/httpManager";

export async function fetchAllActivesPortfolios() {
  const url = `/portfolios/active/`;
  const response = await httpManager.get(url);
  return response?.data.results;
}
